// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"vg","hidden":"wg","preventTransition":"xg","divBgImg":"yg","loaded":"zg"};